import styled from 'styled-components';
import { Box, Icon, Space, TextBody } from '@ally/metronome-ui';
import { muiThirdPartyEqualHousing } from '@ally/metronome-icons';
import { Row, Link } from '../../atoms';
import { LeavingAllyModal } from '../../organisms';
import { PdfModal } from '../../organisms';

const StyledLink = styled(Link)`
  ${({ theme: { colors } }): string => `
    color: ${colors['blue-800']};
  `}
`;

interface IProps {}

// TODO: Fix white spacing on commit
const Footer: React.FC<IProps> = (props) => {
  return (
    <Row>
      <Box display='flex' justifyContent='center' marginBottom='xl'>
        <Space paddingX={['5px', '25px']}>
          <StyledLink
            to='https://www.ally.com/do-it-right/'
            text='Ally Community'
            target='_blank'
          />
          <StyledLink
            to='https://www.ally.com/security/'
            text='Security'
            target='_blank'
          />
          <StyledLink
            to='https://www.ally.com/privacy/'
            text='Privacy'
            target='_blank'
          />
          <StyledLink
            to='https://www.ally.com/legal/'
            text='Legal'
            target='_blank'
          />
        </Space>
      </Box>
      <Space marginBottom='13px'>
        <TextBody tag='p' size='sm'>
          Ally Financial Inc. (NYSE: ALLY) is a leading digital financial
          services company. Ally Bank, the company's direct banking subsidiary,
          offers an array of deposit products and services. Ally Bank is a
          Member FDIC and Equal Housing Lender{' '}
          <Icon icon={muiThirdPartyEqualHousing} fill='gray-800' />,{' '}
          <LeavingAllyModal
            variant='link'
            to='https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/181005'
            text='NMLS ID 181005'
          />
          . Credit products are subject to approval and additional terms and
          conditions apply. Programs, rates and terms and conditions are subject
          to change at any time without notice.
        </TextBody>
        <TextBody tag='p' size='sm'>
          Securities products and services are offered through Ally Invest
          Securities LLC, member{' '}
          <LeavingAllyModal
            variant='link'
            to='https://www.finra.org/'
            text=' FINRA '
          />
          /
          <LeavingAllyModal
            variant='link'
            to='http://www.sipc.org/'
            text=' SIPC '
          />
          . For background on Ally Invest Securities, go to{' '}
          <LeavingAllyModal
            variant='link'
            to='http://brokercheck.finra.org/firm/136131'
            text="FINRA's BrokerCheck"
          />
          . Advisory services are offered through Ally Invest Advisors Inc., a
          registered investment adviser.{' '}
          <StyledLink
            target='_blank'
            to='https://www.ally.com/invest/disclosures/#securities '
            text='View Invest Disclosures'
          />
          . Ally Invest Advisors and Ally Invest Securities are wholly owned
          subsidiaries of Ally Financial Inc. Securities products are
          <TextBody tag='span' size='sm' weight='bold'>
            {' '}
            NOT FDIC INSURED, NOT BANK GUARANTEED,
          </TextBody>{' '}
          and
          <TextBody tag='span' size='sm' weight='bold'>
            {' '}
            MAY LOSE VALUE.
          </TextBody>
        </TextBody>
        <TextBody tag='p' size='sm'>
          Trading on margin involves risk. You can lose more funds than you
          deposit in a margin account. Review{' '}
          <StyledLink
            target='_blank'
            to='https://www.ally.com/invest/disclosures/margin-account-agreement-and-disclosure/'
            text='Margin Account Agreement and Disclosure'
          />{' '}
          for more information regarding margin trading.
        </TextBody>
        <TextBody tag='p' size='sm'>
          Options involve risk and aren't suitable for all investors. Review the{' '}
          <LeavingAllyModal
            variant='link'
            to='https://www.theocc.com/Company-Information/Documents-and-Archives/Options-Disclosure-Document'
            text='Characteristics and Risks of Standardized Options brochure'
          />{' '}
          before you begin trading options. Options investors may lose the
          entire amount of their investment, or more, in a relatively short
          period of time.
        </TextBody>
        <TextBody tag='p' size='sm'>
          Before you invest, you should carefully review and consider the
          investment objectives, risks, charges and expenses of any mutual fund
          or exchange-traded fund (ETF) you're considering. ETF trading prices
          may not necessarily reflect the net asset value of the underlying
          securities. A mutual fund/ETF prospectus contains this and other
          information and can be obtained by emailing{' '}
          <StyledLink
            variant='link'
            to='mailto:support@invest.ally.com'
            text='support@invest.ally.com'
          />
          .
        </TextBody>
        <TextBody tag='p' size='sm'>
          Ally Invest doesn't charge commissions for stocks and ETFs priced $2
          and higher. Stocks priced less than $2 are charged a base commission
          up to $4.95 plus $0.01 per share on the entire order. Certain option
          index products add an additional $0.35 cents per contract where the
          exchanges charge fees. See our{' '}
          <StyledLink
            target='_blank'
            to='https://www.ally.com/invest/commissions-and-fees/'
            text='Commissions and Fees page'
          />{' '}
          for more information.
        </TextBody>
        <TextBody tag='p' size='sm'>
          Ally Invest Securities provides third-party research for information
          purposes only and doesn't offer investment advice or personalized
          recommendations. Investors assume the risk of relying on these
          research services to make investing decisions. Review{' '}
          <PdfModal
            variant='link'
            to='https://www.ally.com/content/dam/pdf/invest/market_data_disclosure_and_subscriber_agreements.pdf'
            text='Content Providers and Disclosures'
          />{' '}
          for more information.
        </TextBody>
        <TextBody tag='p' size='sm'>
          ©2009-2025 Ally Financial Inc.
        </TextBody>
      </Space>
    </Row>
  );
};

export default Footer;
